export const POSTMODAL = "postModal";
export const PROFILEMODAL = "profileModal";
